module.exports = __webpack_public_path__ + "img/gych1.4b4c56ff.jpg";